import { useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { subdivisionModel } from '~/entities/common/Taxipark/Subdivisions'
import {
  EditSubdivision,
  editSubdivisionModel,
} from '~/features/common/Taxipark/Subdivisions/EditSubdivision'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'
import { NotFound } from '~/shared/ui/NotFound'

export const EditSubdivisionPage = () => {
  const { t } = useTranslation()
  const { subdivisionId } = useParams<{ subdivisionId: string }>()

  const isLoading = useStore(subdivisionModel.requestFx.pending)
  const title = useStoreMap(editSubdivisionModel.$subdivision, (subdivision) =>
    subdivision?.getTitle(),
  )

  const breadcrumbs: BreadcrumbsList = useMemo(
    () => [
      { title: 'subdivisions', link: '/taxipark/subdivisions' },
      { title: title || '' },
    ],
    [title],
  )

  const error = subdivisionModel.useSubdivisionError(subdivisionId as string)

  if (!subdivisionId || error) {
    return <NotFound message={t('alert.failed to load subdivision')} />
  }

  return (
    <PageContainer title={t('subdivision card')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} lastLoading={isLoading} />
        <PageTitle loading={isLoading}>{title}</PageTitle>
      </Container>

      <EditSubdivision subdivisionId={subdivisionId} />
    </PageContainer>
  )
}
